import { IGlobalReducerState } from '../Base/interface/IGlobalReducerState';

const getIsCollapsed = (state: IGlobalReducerState) => state.obra.isCollapsed;

export { getIsCollapsed };
